import { atom } from "jotai";

import {
  VideoAdsQuizOption,
  VideoAdsQuizQuestion,
} from "./video-ads-quiz.types";

export const initVideoAdQuestion: VideoAdsQuizOption[] = [
  {
    id: "correctOptionId",
    textOption: "Yes",
    isCorrect: true,
    isSelected: false,
  },
  {
    id: "incorrectOptionId",
    textOption: "No",
    isCorrect: false,
    isSelected: false,
  },
];

export const videoAdsQuestionCounterAtom = atom<number>(0);
export const videoAdsGrantedEntriesCounterAtom = atom<number>(0);
export const videoAdsQuizQuestionsAtom = atom<VideoAdsQuizQuestion[]>([]);
export const videoAdsQuizCurrentQuestionAtom = atom<VideoAdsQuizQuestion>({
  id: `question-0`,
  options: initVideoAdQuestion,
  answer: false,
});
export const videoAdFinishedAtom = atom<boolean>(false);
